export default __webpack_public_path__ + "static/media/toyota-protect-your-coverage.4c5166a8.svg";